import React from 'react'
import PropTypes from 'prop-types'
import styles from './LightSlatePlugin.scss'

const LightNode = ({ attributes, children }) => (
  <span {...attributes} style={{fontWeight: 'lighter'}} className={styles.LightNode}>
    {children}
  </span>
)

LightNode.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node
}

export default LightNode



// WEBPACK FOOTER //
// ./src/components/LightSlatePlugin/LightNode.js